import { SnackbarProvider as NotificationsProvider } from 'notistack'
import { FC } from 'react'
import { ReactQueryDevtools } from 'react-query/devtools'
import { config } from '../../../config'
import { AnalyticsProvider } from './Analytics'
import { AuthProvider } from './Auth'
import { FeatureFlagProvider } from './FeatureFlag'
import { FrameDetectionProvider } from './FrameDetection'
import { QueryProvider } from './Query'
import { ThemeProvider } from './Theme'
import {
  CustomerProfileProvider,
  CustomerProvider,
  FirstAvailabilityProvider,
  LocaleProvider,
  MixpanelProvider,
  ReferrerProvider,
  RescheduleProvider,
  ShopProvider,
} from '../../../hooks'

const Providers: FC = ({ children }) => (
  <LocaleProvider>
    <FrameDetectionProvider>
      <AuthProvider>
        <QueryProvider>
          <FeatureFlagProvider>
            <MixpanelProvider>
              <FirstAvailabilityProvider>
                <ThemeProvider>
                  <NotificationsProvider>
                    <ShopProvider>
                      <CustomerProfileProvider>
                        <CustomerProvider>
                          <AnalyticsProvider>
                            <ReferrerProvider>
                              <RescheduleProvider>{children}</RescheduleProvider>
                            </ReferrerProvider>
                          </AnalyticsProvider>
                        </CustomerProvider>
                      </CustomerProfileProvider>
                    </ShopProvider>
                    {config.REACT_QUERY_DEV_TOOLS_ENABLED && <ReactQueryDevtools />}
                  </NotificationsProvider>
                </ThemeProvider>
              </FirstAvailabilityProvider>
            </MixpanelProvider>
          </FeatureFlagProvider>
        </QueryProvider>
      </AuthProvider>
    </FrameDetectionProvider>
  </LocaleProvider>
)

export { Providers }
